import(/* webpackMode: "eager" */ "/home/runner/work/project-octopus/project-octopus/website/app/src/app/page.tsx");
